import { Inject, Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { API_BASE_URL } from "../service-proxies/service-proxies";

@Injectable({
  providedIn: "root",
})
export class ApiInterceptorInterceptor implements HttpInterceptor {
  baseUrl: string;

  constructor(@Inject(API_BASE_URL) baseUrl?: string) {
    this.baseUrl = baseUrl ? baseUrl : "";
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // console.log("og url", request.url);
    const apiReq = request.clone({ url: this.baseUrl + request.url });
    // console.log("Interceptor===>", apiReq);
    return next.handle(apiReq);
  }
}
